import { type LucideIcon, Box, GitBranch, Package } from 'lucide-react';

import {
  GithubComPortainerPortainerApiGitopsWorkflowsStatus,
  SourcesSourceType,
  SourcesProvider,
} from '@api/types.gen';

export type SourceStatus = GithubComPortainerPortainerApiGitopsWorkflowsStatus;
export type SourceType = SourcesSourceType;

export interface Source {
  id: number;
  name: string;
  type: SourceType;
  url: string;
  status: SourceStatus;
  error?: string;
  provider?: SourcesProvider;
  usedBy: number;
  environments: number;
  lastSync: number;
}

export const SOURCE_TYPES: Record<
  SourceType,
  { label: string; icon: LucideIcon }
> = {
  git: { label: 'Git', icon: GitBranch },
  helm: { label: 'Helm', icon: Package },
  oci: { label: 'OCI', icon: Box },
};
